import styled from 'styled-components';

export const MappingItemBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${(p) => p.theme.spacing.getSize(3)};
  padding: ${(p) => p.theme.spacing.getSize(3)};
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  border-radius: ${(p) => p.theme.spacing.borderRadius};
  box-sizing: border-box;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p) => p.theme.colors.primary.getValue(500).main};
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Name = styled.span`
  font-size: ${(p) => p.theme.type.getSize(0)};
  line-height: 1.5;
  word-break: break-word;
  flex: 1;
`;

export const DeleteButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
`;
